import { GET, POST } from './api'

const pathByType = {
  courses: 'courses',
  'partners-and-staffs': 'partners-and-staffs',
}

const getModulePayload = (type, moduleId) => (
  type === 'partners-and-staffs'
    ? { partners_and_staff_module: moduleId }
    : { course_module: moduleId }
)

export const readCourseDetails = async (type, id, locale) => {
  const path = pathByType[type]
  if (!path || !id) return false

  return GET(`/${path}/${id}/details${locale ? `?locale=${encodeURIComponent(locale)}` : ''}`, true)
}

export const readWistiaTranscript = async (mediaId, options = {}) => {
  if (!mediaId) return false

  const params = new URLSearchParams()
  if (options.language) params.set('language', options.language)
  if (options.locale) params.set('locale', options.locale)
  if (options.type) params.set('type', options.type)
  if (options.moduleId) params.set('moduleId', options.moduleId)
  if (options.lessonId) params.set('lessonId', options.lessonId)
  const query = params.toString() ? `?${params.toString()}` : ''

  return GET(`/wistia/transcripts/${encodeURIComponent(mediaId)}${query}`, true)
}

export const isLessonTranscriptVisible = lesson => lesson?.show_transcript !== false

export const toggleLessonFavorite = async (type, moduleId, lessonId) => {
  return POST('/favorites/toggle', {
    data: {
      ...getModulePayload(type, moduleId),
      lesson: lessonId,
    },
  }, true)
}

export const completeLesson = async (type, moduleId, lessonId) => {
  return POST('/course-progresses/complete', {
    data: {
      ...getModulePayload(type, moduleId),
      lesson: lessonId,
    },
  }, true)
}
